import { memo } from 'react';
import { Typography } from '@components/styledComponents';
import { DataGrid } from '@mui/x-data-grid';

function SelectedPropertiesTable({ properties, onCellEditCommit }) {
  return (
    <div style={{ width: '100%' }}>
      <Typography
        variant="h4"
        sx={{ marginBottom: '16px' }}>
        Set values of selected properties
      </Typography>
      <DataGrid
        autoHeight
        onCellEditCommit={onCellEditCommit}
        rows={properties}
        columns={[
          {
            field: 'key',
            editable: false,
            sortable: false,
            headerName: 'Key',
            flex: 1,
          },
          {
            field: 'description',
            editable: false,
            sortable: false,
            headerName: 'Description',
            headerAlign: 'center',
            flex: 1,
          },
          {
            field: 'value',
            editable: true,
            sortable: false,
            headerName: 'Value',
            headerAlign: 'center',
            flex: 3,
          },
        ]}
        disableSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        density="standard"
        getRowId={(row) => row.id}
        pageSize={10}
        rowsPerPageOptions={[10]}
      />
    </div>
  );
}

export default memo(SelectedPropertiesTable);
